import React from 'react'
import PropTypes from 'prop-types'
import MutableConnect from '../../utils/MutableConnect'

import LoadingHandler from '../../components/loading/LoadingHandler'

const LoadingContainer = (props) => {
  const { busyFetchingStudies } = props
  if (busyFetchingStudies) {
    const loadingArray = [
      {
        isLoading: busyFetchingStudies,
        message: "Loading Study Admin Portal",
      }]
    return (
      <div className="loading-container">
        <LoadingHandler loading={ loadingArray } />
      </div>
    )
  }
  return null
}

LoadingContainer.propTypes = { busyFetchingStudies: PropTypes.bool.isRequired }

const mapStateToProps = state => ({ busyFetchingStudies: state.studies.busyFetchingStudies })

export default MutableConnect(mapStateToProps, null)(LoadingContainer)
